/**
 * The day strip of the booking (owner 27.10.2026): every day from today, the ones without times
 * dimmed. `dates` are the days with free time for the treatment (any offered therapist);
 * `staffDays` maps a day to the therapists who have time that day.
 */
export function dayStrip(from: string, count: number): string[] {
  const out: string[] = [];
  const d = new Date(`${from}T12:00:00Z`);
  for (let i = 0; i < count; i++) {
    out.push(d.toISOString().slice(0, 10));
    d.setUTCDate(d.getUTCDate() + 1);
  }
  return out;
}

/** Days the client may tap: with a therapist chosen, only her days (when known). */
export function bookableDays(
  dates: string[],
  staffFilter: string | undefined,
  staffDays: Record<string, string[]>,
): string[] {
  if (!staffFilter || Object.keys(staffDays).length === 0) return dates;
  return dates.filter((d) => staffDays[d]?.includes(staffFilter));
}
